import { Link, useLocation } from "react-router-dom";
import styles from "./AdminNav.module.css";

const LINKS = [
  { to: "/admin", label: "Bookings" },
  { to: "/admin/reviews", label: "Reviews" },
];

function AdminNav() {
  const { pathname } = useLocation();

  return (
    <div className={styles.nav}>
      {LINKS.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className={`${styles.link} ${pathname === item.to ? styles.linkActive : ""}`}
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
}

export default AdminNav;
